/*
 * @Author: han
 * @Date: 2021-05-19 15:47:57
 * @LastEditors: han
 * @LastEditTime: 2021-06-10 13:40:03
 * @Description: 测评中心
 */
const routes = [
  {
    path: "/evaluation/edittemplate",
    name: "editTemplate",
    component: () => import("../pages/evaluation/editTemplate.vue"),
  },
  {
    path: "/evaluation/edittemplateFineArts",
    name: "edittemplateFineArts",
    component: () => import("../pages/evaluation/editTemplateFineArts.vue"),
  },
  {
    path: "/evaluation/edittemplateModel",
    name: "edittemplateModel",
    component: () => import("../pages/evaluation/editTemplateModel.vue"),
  },
  {
    path: "/evaluation/edittemplateSports",
    name: "edittemplateSports",
    component: () => import("../pages/evaluation/edittemplateSports.vue"),
  },
  {
    path: "/evaluation/edittemplateMusic",
    name: "edittemplateMusic",
    component: () => import("../pages/evaluation/edittemplateMusic.vue"),
  },
  {
    path: "/evaluation/previewTemplate",
    name: "previewTemplate",
    component: () => import("../pages/evaluation/previewTemplate.vue"),
  },
  {
    path: "/evaluation",
    name: "evaluationHome",
    component: () => import("../pages/evaluation/evaluationHome.vue"),
    children: [
      {
        path: "/report",
        component: () => import("../pages/evaluation/report.vue")
      },
      {
        path: "/administration",
        component: () => import("../pages/evaluation/administration.vue")
      }
    ]
  },
  {
    path: "/evaluation/recommend",
    name: "recommend",
    component: () => import("../pages/evaluation/recommend.vue")
  }
];

export default routes;
